import { getToken } from 'data/auth/utils'
import { EntityId } from 'entities-next/common'
import { createApiHandler, CreateApiHandlerConfig } from 'services-next/api'
import { createEntityParser, getUrlWithPathParams } from 'utils-next/api'
import { PaginationOptions } from 'utils-next/types'

import { parseApiUser } from './user.config'
import { ApiUserData, User, UserRole } from './user.types'
import { PagedResult } from '../../utils/pagedResult'

const USER_ENDPOINT_PATH = 'admin/users'
const DUMMY_PASSWORD = 'dummy!Pass'

export type UserListFilters = {
  corporateId?: EntityId
  role?: UserRole
  name?: string
  email?: string
}

export function getApiUserHandlers(customToken?: string, config: Omit<CreateApiHandlerConfig, 'baseUrl'> = {}) {
  const token = customToken || getToken() || undefined
  const transformResponse = createEntityParser(parseApiUser)
  const { callApi } = createApiHandler(token, { ...config, transformResponse })

  async function apiGetUserList(
    filters: UserListFilters,
    paginationOptions: PaginationOptions
  ): Promise<PagedResult<User>> {
    return await callApi<PagedResult<User>>({
      url: USER_ENDPOINT_PATH,
      params: {
        ...filters,
        page: paginationOptions.currentPage + 1,
        limit: paginationOptions.limit,
      },
    })
  }

  async function apiGetOpsLeadList(search?: string): Promise<PagedResult<User>> {
    return await callApi<PagedResult<User>>({
      url: USER_ENDPOINT_PATH,
      params: {
        page: 1,
        limit: 50,
        admin: true,
        name: search,
      },
    })
  }

  async function apiGetUser(id: EntityId): Promise<User> {
    return callApi<User>({
      url: getUrlWithPathParams(USER_ENDPOINT_PATH, id),
    })
  }

  async function apiCreateUser(user: ApiUserData): Promise<User> {
    return callApi<User>({
      method: 'POST',
      url: USER_ENDPOINT_PATH,
      data: {
        ...user,
        password: DUMMY_PASSWORD,
      },
    })
  }

  async function apiUpdateUser(id: EntityId, user: ApiUserData): Promise<User> {
    return callApi<User>({
      method: 'PUT',
      url: getUrlWithPathParams(USER_ENDPOINT_PATH, id),
      data: user,
    })
  }

  async function apiDeleteUser(userId: EntityId): Promise<void> {
    return callApi<void>({
      method: 'DELETE',
      url: getUrlWithPathParams(USER_ENDPOINT_PATH, userId),
    })
  }

  return {
    apiGetUserList,
    apiGetOpsLeadList,
    apiGetUser,
    apiDeleteUser,
    apiCreateUser,
    apiUpdateUser,
  }
}
